import Vue from "vue";
import App from "../App/App.vue";
import WinterCourseYear from "./WinterCourseYear.vue";
var vm = window.$vm = new Vue({
    name: "App",
    el: "app",
    components: {
        App: App,
        WinterCourseYear: WinterCourseYear
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/WinterCourseYear/Index.cshtml.ts
// module id = 1296
// module chunks = 5